/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { compact, map, uniq } from 'lodash';

import logger from 'js/app/loggerSingleton';
import { FormattedNumber } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import type { PartnerListingPagePartnerFragment as PartnerListingPagePartner } from 'bundles/partners-graphql/queries/__generated__/GetAllPartners';

import _t from 'i18n!nls/partners-graphql';

const styles = {
  partnersListingHeaderStats: css`
    position: absolute;
    bottom: 25px;
    left: 0;
    right: 0;
    text-align: center;

    .stats {
      display: inline-block;

      @media (max-width: 767px) {
        display: block;
      }

      .delim {
        margin: 0 15px;
        font-weight: bold;
        font-size: 18px;

        @media (max-width: 767px) {
          display: none;
        }
      }
    }
  `,
};

type PropsFromCaller = {
  partners: Array<PartnerListingPagePartner>;
};

const PartnerListingHeaderStats = ({ partners }: PropsFromCaller) => {
  const partnerCountriesRepresented = (): Array<string> => {
    return uniq(compact(map(partners, (partner) => partner.location && partner.location.country)));
  };

  const renderStatItem = (prefix: $TSFixMe, count: $TSFixMe, suffix: $TSFixMe): JSX.Element | null => {
    if (!count) {
      logger.error('Incomplete stat');
      return null;
    }

    return (
      <span className="stat">
        {prefix && (
          <Typography2 component="span" variant="bodySecondary" color="invertBody" className="prefix">
            {prefix}
            &nbsp;
          </Typography2>
        )}
        <Typography2 component="span" variant="bodySecondary" color="invertBody" className="number">
          <FormattedNumber value={count} />
        </Typography2>
        <Typography2 component="span" variant="bodySecondary" color="invertBody" className="noun">
          &nbsp;{suffix}
        </Typography2>
      </span>
    );
  };

  const partnerCount = partners.length;
  const partnerCountryCount = partnerCountriesRepresented().length;
  return (
    <div css={styles.partnersListingHeaderStats} className="rc-PartnerListingHeaderStats">
      <div className="stats">
        {renderStatItem(null, partnerCount, _t('partners'))}
        <span className="delim">·</span>
        {renderStatItem(_t('across'), partnerCountryCount, _t('countries'))}
      </div>
    </div>
  );
};

export default PartnerListingHeaderStats;
